module.exports = __webpack_public_path__ + "static/media/boca_tecidos_moles.c00d0034.svg";